// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwLabel from 'viewmodel/AwLabelViewModel';
import AwSearchBox from 'viewmodel/AwSearchBoxViewModel';
import AwChipList from 'viewmodel/AwChipListViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwCheckbox from 'viewmodel/AwCheckboxViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
    import { ExistWhen,EnableWhen } from 'js/hocCollection';
const DivExistWhen = ExistWhen('div');
const AwButtonEnableWhen = EnableWhen(AwButton);
DivExistWhen.displayName = 'DivExistWhen';
AwButtonEnableWhen.displayName = 'AwButtonEnableWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/DesDownloadService', () => import('js/DesDownloadService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "lifecycleHooks": {
        "onMount": "getCatalogAttachments",
        "onUpdate": [
            {
                "action": "getCatalogAttachments",
                "observers": [
                    "props.provider",
                    "props.item",
                    "props.accsessionid",
                    "props.containertype",
                    "props.catalogspaceid"
                ]
            },
            {
                "action": "getListOfCheckBox",
                "observers": [
                    "data.listOfValues"
                ]
            }
        ]
    },
    "data": {
        "closeAnchor": "commandPanelcloseAnchor",
        "partAttachmentsDropdown": {
            "displayName": "{{i18n.selectFileFormat}}",
            "type": "CHECKBOX",
            "isArray": true,
            "dataProvider": "partAttachmentsProvider",
            "renderingHint": "checkboxoptionlov"
        },
        "searchBoxlabel": {
            "displayName": "{{i18n.searchBoxdisplayName}}",
            "type": "STRING"
        },
        "searchBox": {
            "displayName": "{{i18n.searchBoxdisplayName}}",
            "type": "STRING",
            "dbValue": ""
        },
        "searchBoxPlaceHolder": {
            "dbValue": "{{i18n.searchBoxplaceholder}}"
        },
        "checkBoxSelectionArray": [],
        "filterCheckBoxList": [],
        "isResult": true,
        "noResultFound": false,
        "resultNotFound": {
            "displayName": "Label",
            "dbValue": "",
            "type": "STRING",
            "dispValue": "No results found",
            "labelPosition": "NO_PROPERTY_LABEL"
        },
        "selectedCheckBoxToChips": []
    },
    "dataProviders": {
        "partAttachmentsProvider": {
            "action": "getCatalogAttachments",
            "response": "{{data.catalogPartAttachments}}",
            "selectionModelMode": "multiple",
            "totalFound": "{{data.totalFound}}"
        },
        "selectedfileAttachmentDataProvider": {
            "type": "Static",
            "response": "{{data.selectedCheckBoxToChips}}",
            "selectionModelMode": "none"
        }
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "item": {
            "type": "string"
        },
        "containertype": {
            "type": "string"
        },
        "provider": {
            "type": "string"
        },
        "catalogspaceid": {
            "type": "string"
        },
        "locale": {
            "type": "string"
        }
    },
    "actions": {
        "getCatalogAttachments_1": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "provider": "{{props.provider}}",
                            "accsessionid": "{{props.accsessionid}}"
                        },
                        "appBaseUrl": "assets",
                        "query": "query GetCatalogPartAttachments( $catalogspaceId: String, $containerId: String, $partUrn: String, $locale: String ) { getCatalogPartAttachments( catalogspaceId: $catalogspaceId, containerId: $containerId, partUrn: $partUrn, $locale: String ) }",
                        "variables": {
                            "catalogspaceId": "{{props.catalogspaceid}}",
                            "containerId": "{{props.containerId || ''}}",
                            "partUrn": "{{props.item}}",
                            "locale": "{{props.locale}}"
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "catalogPartAttachments_1": "data.data.getCatalogPartAttachments.attachments2",
                "catalogAttachmentName": "data.data.getCatalogPartAttachments.name",
                "catalogAttachmentPath": "data.data.getCatalogPartAttachments.path",
                "totalFound_1": "data.data.getCatalogPartAttachments.totalFound"
            },
            "deps": "js/accHttpService"
        },
        "getCatalogAttachments": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "provider": "{{props.provider}}",
                            "accsessionid": "{{props.accsessionid}}"
                        },
                        "appBaseUrl": "assets",
                        "query": "query GetCatalogPartAttachments( $catalogspaceId: String, $containerId: String, $partUrn: String ) { getCatalogPartAttachments( catalogspaceId: $catalogspaceId, containerId: $containerId, partUrn: $partUrn ) }",
                        "variables": {
                            "catalogspaceId": "{{props.catalogspaceid}}",
                            "containerId": "{{props.containerId || ''}}",
                            "partUrn": "{{props.item}}"
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "partAttachmentsResponse": "data.data.getCatalogPartAttachments.output.data.product.attachments",
                "catalogPartAttachments": "data.data.getCatalogPartAttachments.partAttachments.attachments2",
                "totalFound": "data.data.getCatalogPartAttachments.partAttachments.totalFound"
            },
            "events": {
                "success": [
                    {
                        "name": "getCatalogAttachmentsSuccess",
                        "eventData": {
                            "eventName": "getCatalogAttachmentsSuccess",
                            "catalogPartAttachments": "{{catalogPartAttachments}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "downloadAction": {
            "actionType": "JSFunction",
            "method": "downloadFiles",
            "inputData": {
                "data": "{{data}}",
                "i18n": "{{i18n}}"
            },
            "deps": "js/DesDownloadService"
        },
        "doSearchDownload": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "searchDownloadInitiated",
                        "eventData": {
                            "eventName": "searchDownloadInitiated",
                            "searchInput": "{{data.searchBox.dbValue}}"
                        },
                        "condition": "data.searchBox.dbValue && data.searchBox.dbValue.length > 0"
                    }
                ]
            }
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "getListOfCheckBox": {
            "actionType": "JSFunction",
            "method": "getListOfCheckBox",
            "inputData": {
                "catalogPartAttachment": "{{parameters.eventData || ''}}",
                "filterStr": "{{parameters.filterStr || ''}}",
                "vmo": "{{data}}"
            },
            "outputData": {
                "listOfValues": ""
            },
            "events": {
                "success": [
                    {
                        "name": "getListOfCheckBox.success"
                    }
                ]
            },
            "deps": "js/DesDownloadService"
        },
        "updateSelection": {
            "actionType": "JSFunction",
            "method": "updateSelectionCheckBox",
            "inputData": {
                "data": "{{data}}"
            },
            "outputData": {
                "checkBoxSelectionArray": ""
            },
            "deps": "js/DesDownloadService"
        },
        "performBatchActionOnSearch": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "getListOfCheckBox"
                },
                {
                    "action": "publishToACCEventBus"
                }
            ]
        },
        "getFilteredFileAttchmentsList": {
            "actionType": "JSFunction",
            "method": "getFilteredFileAttchmentsList",
            "inputData": {
                "data": "{{data}}",
                "filterStr": "{{parameters.eventData}}"
            },
            "outputData": {
                "checkBoxSelectionArray": ""
            },
            "deps": "js/DesDownloadService"
        },
        "removeSelectedChipAction": {
            "actionType": "JSFunction",
            "method": "removeSelectedChip",
            "inputData": {
                "chipArray": "{{data.selectedCheckBoxToChips}}",
                "chipToRemove": "{{parameters.chip}}",
                "vmo": "{{data}}"
            },
            "outputData": {
                "selectedCheckBoxToChips": ""
            },
            "events": {
                "success": [
                    {
                        "name": "selectedfileAttachmentDataProvider.reset"
                    }
                ]
            },
            "deps": "js/DesDownloadService"
        }
    },
    "onEvent": [
        {
            "eventId": "searchDownloadInitiated",
            "action": "performBatchActionOnSearch",
            "inputArgs": {
                "eventName": "{{eventData.eventName}}",
                "filterStr": "{{eventData.searchInput}}"
            }
        },
        {
            "eventId": "getCatalogAttachmentsSuccess",
            "action": "getListOfCheckBox",
            "inputArgs": {
                "eventName": "{{eventData.eventName}}",
                "eventData": "{{eventData.catalogPartAttachments}}"
            }
        }
    ],
    "i18n": {
        "selectFileFormat": [
            "DesDownloadMessages"
        ],
        "cancel": [
            "DesDownloadMessages"
        ],
        "download": [
            "DesDownloadMessages"
        ],
        "downloadPart": [
            "DesDownloadMessages"
        ],
        "searchBoxplaceholder": [
            "DesDownloadMessages"
        ],
        "searchBoxdisplayName": [
            "DesDownloadMessages"
        ],
        "close": [
            "DesDownloadMessages"
        ],
        "downloadMessage": [
            "DesDownloadMessages"
        ],
        "downloadMessageForMultipleFiles": [
            "DesDownloadMessages"
        ]
    },
    "conditions": {
        "existCatalogListbox": {
            "expression": "props.containertype === catalog"
        },
        "existLibraryListbox": {
            "expression": "props.containertype === library"
        },
        "enableDownloadButton": {
            "expression": "data.checkBoxSelectionArray.length > 0"
        },
        "showResults": {
            "expression": "data.isResult"
        },
        "noResultFound": {
            "expression": "data.noResultFound"
        },
        "showChips": {
            "expression": "data.selectedCheckBoxToChips.length > 0"
        }
    },
    "_viewModelId": "DesDownload",
    "_uniqueViewModelId": "DesDownload",
    "ctx": {}
};

    /*
    <aw-panel class="aw-layout-full">
    <!-- search box for file search -->
    <aw-label prop="data.searchBoxlabel"></aw-label>
    <aw-search-box prop="data.searchBox" placeholder="data.searchBoxPlaceHolder.dbValue" action="doSearchDownload"
        reset-action="getListOfCheckBox" change-action="getListOfCheckBox">
    </aw-search-box>
    <!-- selected file in the form of chip -->
    <div exist-when="conditions.showChips">
        <aw-chip-list dataprovider="data.dataProviders.selectedfileAttachmentDataProvider"
            action="removeSelectedChipAction" ui-icon-action="removeSelectedChipAction"
            class="chip-container">
        </aw-chip-list>
    </div>
    <!-- render list of checkbox -->
    <aw-panel-body>
        <div aw-repeat="item:data.listOfValues">
            <div exist-when="conditions.showResults">
                <aw-checkbox prop="item" action="updateSelection"></aw-checkbox>
            </div>
        </div>
        <div exist-when="conditions.noResultFound">
            <aw-label prop='data.resultNotFound'></aw-label>
        </div>
    </aw-panel-body>
    <aw-panel-footer>
        <aw-button enable-when="conditions.enableDownloadButton" action="downloadAction">{{i18n.download}}</aw-button>
    </aw-panel-footer>
</aw-panel>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}  className="aw-layout-full">
        <AwLabel {...getField("data.searchBoxlabel", fields, $index, null, null )}>
        </AwLabel>
        <AwSearchBox {...getField("data.searchBox", fields, $index, null, null )} placeholder={AwParseService.instance( "data.searchBoxPlaceHolder.dbValue" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} action={actions.doSearchDownload} resetAction={actions.getListOfCheckBox} changeAction={actions.getListOfCheckBox}>
        </AwSearchBox>
        <DivExistWhen existWhen={AwParseService.instance( "conditions.showChips" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
            <AwChipList  dataprovider={dataProviders.selectedfileAttachmentDataProvider}  chipCondition={AwParseService.instance( "{conditions}" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} action={actions.removeSelectedChipAction} uiIconAction={actions.removeSelectedChipAction} className="chip-container">
            </AwChipList>
        </DivExistWhen>
        <AwPanelBody>
            { Object.entries( AwParseService.instance( "data.listOfValues" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } ) || [] ).map( ( [ $index, item ] ) => (
                <div key={$index}>
                    <DivExistWhen existWhen={AwParseService.instance( "conditions.showResults" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, $index } )}>
                        <AwCheckbox {...getField("item", fields, $index, 'data.listOfValues', {props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, $index}  )} action={actions.updateSelection}>
                        </AwCheckbox>
                    </DivExistWhen>
                </div>
            ) ) }
            <DivExistWhen existWhen={AwParseService.instance( "conditions.noResultFound" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                <AwLabel {...getField("data.resultNotFound", fields, $index, null, null )}>
                </AwLabel>
            </DivExistWhen>
        </AwPanelBody>
        <AwPanelFooter>
            <AwButtonEnableWhen action={actions.downloadAction} enableWhen={AwParseService.instance( "conditions.enableDownloadButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                {AwParseService.instance( "i18n.download" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
            </AwButtonEnableWhen>
        </AwPanelFooter>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;